export default "__VITE_ASSET__i$54Dekj__"